module.exports = __webpack_public_path__ + "static/img/oilcard_bg.077dae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oilcard_bg.png
// module id = ESE4
// module chunks = 0